import React, { Component } from 'react'
import t from 'prop-types'

import {
  Button,
  Modal,
} from 'components/UI'
import ManagerEdit from './ManagerEdit'
import SuperEdit from './SuperEdit'

const UserEdit = ({ role, ...rest }) => {
  switch (role) {
    case 'Manager':
      return <ManagerEdit {...rest} />
    case 'Superintendent':
      return <SuperEdit {...rest} />
    default:
      return <div />
  }
}

class UserEditButton extends Component {
  state = {
    isOpen: false,
  }

  close = () => {
    this.setState({
      isOpen: false,
    })
  }

  open = () => {
    this.setState({
      isOpen: true,
    })
  }

  render () {
    const {
      userId,
      onSuccess,
      role,
      organizationId,
    } = this.props

    return (
      <div>
        <Button onClick={this.open}>Edit</Button>
        { this.state.isOpen &&
          <Modal
            open={true}
            onBlur={this.close}
            width={800}
          >
            <UserEdit
              userId={userId}
              onSuccess={onSuccess}
              onCancel={this.close}
              organizationId={organizationId}
              role={role}
            />
          </Modal>
        }
      </div>
    )
  }
}

UserEditButton.propTypes = {
  onSuccess: t.func.isRequired,
  userId: t.number.isRequired,
  role: t.string.isRequired,
}

export default UserEditButton



// WEBPACK FOOTER //
// ./src/components/Profile/UserEditButton.jsx